import { useMemo } from 'react'
import { Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts'
import { useReportingLocationRatio } from '../api/reporting'
import { Paper } from '../components/paper'

export function LocationChange({ range }: { range: { start: string; end: string } }) {
	const locationRatioQuery = useReportingLocationRatio({
		dateFrom: range.start,
		dateTo: range.end,
	})

	const locationRatioData = useMemo(() => {
		if (!locationRatioQuery.data || locationRatioQuery.data.length === 0) return []

		const totalSame = locationRatioQuery.data.reduce(
			(sum, group) => sum + group.sameLocationCount,
			0,
		)
		const totalDifferent = locationRatioQuery.data.reduce(
			(sum, group) => sum + group.differentLocationCount,
			0,
		)
		const total = totalSame + totalDifferent

		if (total === 0) return []

		return [
			{
				name: 'Ano',
				value: (totalSame / total) * 100,
				count: totalSame,
				color: '#1c36c8',
			},
			{
				name: 'Ne',
				value: (totalDifferent / total) * 100,
				count: totalDifferent,
				color: '#fb7185',
			},
		]
	}, [locationRatioQuery.data])

	return (
		<Paper className="p-4">
			<h3 className="text-lg font-medium text-gray-900 mb-4">
				Vrácení vozidel ve stejné pobočce
			</h3>
			<div className="h-64">
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={locationRatioData}
							dataKey="value"
							nameKey="name"
							cx="50%"
							cy="50%"
							outerRadius={80}
							label
						>
							{locationRatioData.map((entry, index) => (
								<Cell key={`cell-${index}`} fill={entry.color} />
							))}
						</Pie>
						<Tooltip formatter={(value: number) => `${value.toFixed(1)}%`} />
						<Legend />
					</PieChart>
				</ResponsiveContainer>
			</div>
		</Paper>
	)
}
